import { ForgotPasswordStep2 } from "./ForgotPasswordStep2";
import { Step1 } from "./Step1";
import { Step3 } from "./Step3";

export interface ForgotPasswordFormProps {
  changeStep: (step: number) => void;
  step: number;
}

export const ForgotPasswordForm = ({ step, changeStep }: ForgotPasswordFormProps) => {
  if (step === 2) {
    return <ForgotPasswordStep2 changeStep={changeStep} />;
  }

  if (step === 3) {
    return <Step3 />;
  }

  return <Step1 changeStep={changeStep} />;
};
